import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72bf2497"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addWebsiteModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "addWebsiteModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Add target", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = {
  "data-bs-target": "#websiteAddedModal",
  "data-bs-toggle": "modal",
  ref: "showAddedModal"
}
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-dark" }, " An error has occurred and we will NOT automatically scrape your website. Please update your website. ", -1))
const _hoisted_10 = { class: "text-danger" }
const _hoisted_11 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = {
  for: "name",
  class: "form-label"
}
const _hoisted_14 = { class: "text-dark" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_17 = {
  key: 1,
  class: "text-danger ms-1"
}
const _hoisted_18 = {
  key: 0,
  class: "mb-4 position-relative"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "HTTP Headers (optional)", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 2,
  class: "modal-footer"
}
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebsiteConfig = _resolveComponent("WebsiteConfig")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512),
          _withDirectives(_createElementVNode("button", _hoisted_7, " test ", 512), [
            [_vShow, false]
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, " Error: " + _toDisplayString(_ctx.error), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, "Reset")
            ]))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _createElementVNode("b", _hoisted_14, _toDisplayString(_ctx.data.type === 'HEALTHCHECK' ? 'Healtcheck Name' : 'Website URL'), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  placeholder: _ctx.placeholder,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.url) = $event)),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
                }, null, 40, _hoisted_15), [
                  [_vModelText, _ctx.data.url]
                ]),
                (_ctx.data.url && !_ctx.correctWebsiteUrl && !['SUBDOMAIN', 'SSL', 'HEALTHCHECK'].includes(_ctx.data.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " A website URL must start with \"http://\" or \"https://\". "))
                  : _createCommentVNode("", true),
                (_ctx.data.url && _ctx.data.url.startsWith('http') && ['SUBDOMAIN', 'SSL'].includes(_ctx.data.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Please enter a domain WITHOUT https or http "))
                  : _createCommentVNode("", true)
              ]),
              (!['IMAGE', 'SUBDOMAIN', 'SSL', 'HEALTHCHECK'].includes(_ctx.data.type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _hoisted_20,
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (value, name) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: name,
                          class: "header-row"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.headers[name].key) = $event),
                            placeholder: "Key",
                            class: "form-control"
                          }, null, 8, _hoisted_21), [
                            [_vModelText, _ctx.headers[name].key]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.headers[name].value) = $event),
                            placeholder: "Value",
                            class: "form-control"
                          }, null, 8, _hoisted_22), [
                            [_vModelText, _ctx.headers[name].value]
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteHeader(name)),
                            class: "btn btn-outline-danger btn-small"
                          }, "-", 8, _hoisted_23)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addHeader && _ctx.addHeader(...args))),
                        class: "btn btn-outline-primary"
                      }, "+")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_WebsiteConfig, { data: _ctx.data }, null, 8, ["data"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (_ctx.submitted)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Please wait, we analyze your website "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary ms-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                disabled: _ctx.submitted || (!['SUBDOMAIN', 'SSL', 'HEALTHCHECK'].includes(_ctx.data.type) && !_ctx.correctWebsiteUrl) || !_ctx.data.url
              }, _toDisplayString(_ctx.submitted ? "Adding" : "Add"), 9, _hoisted_26)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}